/* eslint-disable @typescript-eslint/no-explicit-any */
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

export function ExceptionUpdated({ data }: { data: any[] }) {
  return (
    <>
      {data.map((item, i) => {
        const displayCode = item.type === "PRODUCT" ? item.sku : item.ncm;

        return (
          <div
            key={i}
            className="border p-4 rounded-md bg-gray-50 mb-4 grid grid-cols-3 gap-4"
          >
            <div className="flex flex-col gap-1">
              <Label className="text-sm text-gray-900">Estado</Label>
              <Input
                value={item.state}
                disabled
                className="bg-gray-100 h-10 text-gray-900"
              />
            </div>

            <div className="flex flex-col gap-1">
              <Label className="text-sm text-gray-900">
                {item.type === "PRODUCT" ? "SKU" : "NCM"}
              </Label>
              <Input
                value={displayCode}
                disabled
                className="bg-gray-100 h-10 text-gray-900"
              />
            </div>

            <div className="flex flex-col gap-1">
              <Label className="text-sm text-gray-900">Tributo</Label>
              <Input
                value={item.exception_type}
                disabled
                className="bg-gray-100 h-10 text-gray-900"
              />
            </div>

            <div className="flex flex-col gap-1">
              <Label className="text-sm text-gray-900">Tipo</Label>
              <Input
                value={item.type}
                disabled
                className="bg-gray-100 h-10 text-gray-900"
              />
            </div>

            <div className="flex flex-col gap-1">
              <Label className="text-sm text-gray-900">Final Anterior</Label>
              <Input
                value={
                  item.old_final_term
                    ? format(new Date(item.old_final_term), "dd/MM/yyyy", {
                        locale: ptBR,
                      })
                    : "Não havia vigência anterior"
                }
                disabled
                className="bg-gray-100 h-10 text-gray-900"
              />
            </div>

            {item.new_final_term && (
              <div className="flex flex-col gap-1">
                <Label className="text-sm text-gray-900">Novo Final</Label>
                <Input
                  value={format(new Date(item.new_final_term), "dd/MM/yyyy", {
                    locale: ptBR,
                  })}
                  disabled
                  className="bg-gray-100 h-10 text-gray-900"
                />
              </div>
            )}
          </div>
        );
      })}
    </>
  );
}
